// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"7f45cbf2","72":"7fd08eee","116":"e1576a67","244":"cf820d2e","464":"5523bf68","490":"2428c8d7","592":"ea555347","636":"ea900ede","766":"894583b8"}[chunkId] + ".chunk.js";
};